<form [formGroup]="form">
    <h1 mat-dialog-title *ngIf="data.id==null">Create Rate Setup</h1>
    <h1 mat-dialog-title *ngIf="data.id!=null">Edit Rate Setup</h1>
    <div mat-dialog-content style="min-height: 400px;">
        <div class="row">
            <!-- <div class="col-md-12">
                <div class="form-group">
                    <label>Parcel *</label>
                    <ng-select [items]="parcelTypeDDL" bindLabel="name" bindValue="value"
                        formControlName="parcelType"></ng-select>

                    <div *ngIf="form.controls['parcelType'].touched && !form.controls['parcelType'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['parcelType'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>

            </div> -->
            <div class="col-md-12">
                <div class="form-group">
                    <label>Rate Type *</label>
                    <ng-select [items]="rateTypeDDL" bindLabel="name" bindValue="value"
                        formControlName="rateType" (change)="rateChange($event)"></ng-select>
                    <div *ngIf="form.controls['rateType'].touched && !form.controls['rateType'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['rateType'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" *ngIf="form.get('rateType').value==0">
                <div class="form-group">
                    <label>Percentage</label>
                    <input type="number" class="form-control" formControlName="ratePercentage">
                    <div *ngIf="form.controls['ratePercentage'].touched && !form.controls['ratePercentage'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['ratePercentage'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-md-12" *ngIf="form.get('rateType').value==1">
                <div class="form-group">
                    <label>Value</label>
                    <input type="number" class="form-control" formControlName="rateValue">
                    <div *ngIf="form.controls['rateValue'].touched && !form.controls['rateValue'].valid">
                        <div *ngFor="let validation of validationMessages.value" class="has-danger">
                            <span class="form-control-feedback"
                                *ngIf="form.controls['rateValue'].hasError(validation.type) ">
                                {{validation.message}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div mat-dialog-actions>
        <button class="btn btn-outline" (click)="onNoClick()">No Thanks</button>
        <button type="button" class="btn btn-primary" style="margin-left: 5px;" [disabled]="!form.valid"
            (click)="save()">Save</button>
    </div>
</form>